module.exports = __webpack_public_path__ + "static/media/logo.b762449e.png";